import { ArrowLeft, LoaderCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { MarkdownArticle } from './MarkdownArticle';
import { SiteFooter } from './SiteFooter';
import { BeadParticleField } from './BeadParticleField';

interface OperationPageData {
  slug: string;
  title: string;
  tags: string[];
  keywords: string;
  body: string;
  heroImage: string;
}

export function OperationPage({ slug }: { slug: string }) {
  const [page, setPage] = useState<OperationPageData | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    setPage(null); setError('');
    fetch(`/api/operation-pages/${encodeURIComponent(slug)}`, { signal: controller.signal, cache: 'no-store' })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.message || '运营页面读取失败');
        setPage(data.page);
      })
      .catch((reason) => { if (reason.name !== 'AbortError') setError(reason.message); });
    return () => controller.abort();
  }, [slug]);
  if (!page && !error) return <main id="primary-content" className="operation-page"><div className="operation-page-state"><LoaderCircle className="spin" size={24} />正在读取页面…</div></main>;
  if (!page) return <main id="primary-content" className="operation-page"><div className="operation-page-state error"><strong>页面暂时无法打开</strong><span>{error}</span><a href="#gallery"><ArrowLeft size={16} />返回广场</a></div></main>;
  return <main id="primary-content" className="operation-page">
    <section className="operation-page-hero" style={page.heroImage ? { backgroundImage: `linear-gradient(90deg,rgba(21,27,38,.92),rgba(21,27,38,.58)),url("${page.heroImage}")` } : undefined}><BeadParticleField /><div><a href="#gallery"><ArrowLeft size={15} />返回广场</a><h1>{page.title}</h1><p>伊小满拼豆网站信息与服务说明</p></div></section>
    <section className="operation-page-body"><aside><strong>页面导航</strong><a href="#gallery">图纸广场</a><a href="#palettes">色卡中心</a><a href="#tutorials">拼豆教程</a><a href="#products">合作商品</a></aside><article className="operation-page-content">
        {!!page.tags.length && <div className="operation-page-tags">{page.tags.map((tag) => <span key={tag}>#{tag}</span>)}</div>}
        <MarkdownArticle body={page.body} className="operation-markdown" />
      </article></section>
    <SiteFooter />
  </main>;
}
